// extracted by mini-css-extract-plugin
export var form = "NewsletterSignup-module--form--e0bc1";
export var headingPrimary = "NewsletterSignup-module--headingPrimary--330d9";
export var headingSecondary = "NewsletterSignup-module--headingSecondary--d991c";
export var newsletterSignup = "NewsletterSignup-module--newsletterSignup--f5db0";